(() => {
  const headerSelector = '.shopify-section--header .header';

  const initHeader = (header) => {
    if (!header || header.dataset.lonevileGlassInitialized === 'true') return;

    header.dataset.lonevileGlassInitialized = 'true';

    let activeMenu = null;
    let animationFrame = 0;
    const drawerMedia = window.matchMedia('(max-width: 999px)');

    const resizeObserver = 'ResizeObserver' in window
      ? new ResizeObserver(() => scheduleUpdate())
      : null;

    const syncDrawerState = () => {
      const drawer = header.querySelector('#menu-drawer');
      const drawerTriggers = header.querySelectorAll('[aria-controls="menu-drawer"]');

      const triggerOpen = Array.from(drawerTriggers).some(
        (trigger) => trigger.getAttribute('aria-expanded') === 'true'
      );

      /* Fallbacks keep the state reliable if Stretch reflects openness on the drawer itself. */
      const drawerOpen = Boolean(
        drawer &&
        (drawer.hasAttribute('open') || drawer.getAttribute('aria-hidden') === 'false')
      );

      header.toggleAttribute(
        'data-lonevile-drawer-open',
        drawerMedia.matches && (triggerOpen || drawerOpen)
      );
    };

    const clearActiveMenu = () => {
      if (activeMenu && resizeObserver) resizeObserver.unobserve(activeMenu);
      activeMenu = null;
      header.removeAttribute('data-lonevile-mega-open');
      header.style.removeProperty('--lonevile-nav-surface-height');
    };

    const updateSurface = () => {
      animationFrame = 0;
      syncDrawerState();

      const trigger = header.querySelector(
        '.header__primary-nav [aria-expanded="true"][aria-controls]'
      );

      if (!trigger) {
        clearActiveMenu();
        return;
      }

      const menuId = trigger.getAttribute('aria-controls');
      const menu = menuId ? document.getElementById(menuId) : null;

      /* Only mega menus extend the glass surface. Native dropdowns and the mobile drawer stay native. */
      if (!menu || !menu.classList.contains('mega-menu')) {
        clearActiveMenu();
        return;
      }

      if (activeMenu !== menu) {
        if (activeMenu && resizeObserver) resizeObserver.unobserve(activeMenu);
        activeMenu = menu;
        if (resizeObserver) resizeObserver.observe(activeMenu);
      }

      header.setAttribute('data-lonevile-mega-open', '');

      const headerRect = header.getBoundingClientRect();
      const menuRect = menu.getBoundingClientRect();
      const surfaceBottom = Math.max(headerRect.bottom, menuRect.bottom);
      const surfaceHeight = Math.max(headerRect.height, surfaceBottom - headerRect.top);

      header.style.setProperty(
        '--lonevile-nav-surface-height',
        `${Math.ceil(surfaceHeight)}px`
      );
    };

    const scheduleUpdate = () => {
      if (animationFrame) cancelAnimationFrame(animationFrame);
      animationFrame = requestAnimationFrame(updateSurface);
    };

    const mutationObserver = new MutationObserver(scheduleUpdate);
    mutationObserver.observe(header, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-expanded', 'aria-hidden', 'open']
    });

    window.addEventListener('resize', scheduleUpdate, { passive: true });
    scheduleUpdate();
  };

  const initAllHeaders = () => {
    document.querySelectorAll(headerSelector).forEach(initHeader);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllHeaders, { once: true });
  } else {
    initAllHeaders();
  }

  /* Re-initialize if Shopify's Theme Editor reloads the header section. */
  document.addEventListener('shopify:section:load', initAllHeaders);
})();
